import React, { useState, useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface WeightInputProps {
    form: UseFormReturn<any>;
    name: string;
    label?: string;
    placeholder?: string;
    required?: boolean;
    className?: string;
}

const WeightInput: React.FC<WeightInputProps> = ({
    form,
    name,
    label,
    placeholder = 'Enter weight',
    required = false,
    className,
}) => {


    return (
        <div className={cn('space-y-2', className)}>
            {label && (
                <Label className={required ? 'required' : ''}>
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </Label>
            )}

            <div className="flex gap-2">

                <div className="flex-1">
                    <div className="flex items-center gap-2">
                        <Input
                            type="number"
                            value={form.watch(name)}
                            onChange={(e)=>{
                                form.setValue(name,e.target.value)
                            }}
                            placeholder={placeholder}
                            name={name}
                            className="flex-1"
                        />
                        <span className="text-sm text-slate-500 font-bold">lbs</span>
                    </div>

                    {form.formState.errors[name] && (
                        <p className="text-[0.8rem] text-red-500">
                            {form.formState.errors[name]?.message as string}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WeightInput;

